import React, { useEffect, useState } from 'react';
import { NewsletterForm } from './newsletter-form.client';
import styles from '../assets/scss/components/newsletter-popup.module.scss';
import { useI18n } from './i18n.client';
import { Image } from '@shopify/hydrogen';

type NewsletterPopupProps = {
  imageSrc?: string;
  description?: string;
};

const NewsletterPopup: React.FC<NewsletterPopupProps> = ({
  imageSrc,
  description,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [i18n] = useI18n();

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('hasSeenNewsletterPopup');
    if (hasSeenPopup) return;

    const delay = Math.floor(Math.random() * (15000 - 5000 + 1)) + 5000;
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('hasSeenNewsletterPopup', 'true');
  };

  if (!isVisible) return null;

  return (
    <div
      className={styles['newsletter-popup-overlay']}
      onClick={handleClose}
    >
      <div
        className={styles['newsletter-popup']}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles['newsletter-popup-close']}
          onClick={handleClose}
          aria-label="Close newsletter popup"
        >
          <img src="/cross.svg" alt="Close" />
        </button>

        {imageSrc && (
          <div className={styles['newsletter-popup-image']}>
            <img src={imageSrc} alt="Newsletter" />
          </div>
        )}
        <div className={styles['newsletter-popup-content']}>
          <Image
            alt={i18n.translate('loop-me-in')}
            height={55}
            src="/loop-me-in.svg"
            width={281}
          />
          <p>{description}</p>
          <NewsletterForm variant="newsletter_subscription_popup" />
        </div>
      </div>
    </div>
  );
};

export default NewsletterPopup;
